import { format } from "date-fns";
import { Account } from "./types";

const MONTHS_IN_YEAR = 12;

function formatLoanTerm(term): string {
  if (term % MONTHS_IN_YEAR === 0) {
    const termInYears = term / MONTHS_IN_YEAR;
    return termInYears === 1 ? "1 Year" : `${termInYears} Years`;
  }
  return term === 1 ? "1 Month" : `${term} Months`;
}

function getOrdinalDay(dayInt): string {
  switch (dayInt) {
    case 1:
    case 21:
    case 31:
      return `${dayInt}st`;
    case 2:
    case 22:
      return `${dayInt}nd`;
    case 3:
    case 23:
      return `${dayInt}rd`;
    default:
      return `${dayInt}th`;
  }
}

export function transformPLDetails(account): Account {
  // TODO: change interface from snake_case to camelCase
  const {
    loan_amount: loanAmount,
    loan_balance: loanBalance,
    payment_schedule: paymentSchedule,
    account_status: accountStatus,
    current_loan_term: currentLoanTerm,
  } = account;

  const isNoPaymentRequired = !paymentSchedule;
  const isFinalPayment =
    !!paymentSchedule && !paymentSchedule.monthly_minimum_payment_amount;
  const isNormalPayment =
    !!paymentSchedule &&
    (!!paymentSchedule.monthly_minimum_payment_amount ||
      paymentSchedule.monthly_minimum_payment_amount === 0);

  const percentagePaid =
    loanAmount &&
    (loanBalance || loanBalance === 0) &&
    loanBalance <= loanAmount
      ? ((loanAmount - loanBalance) / loanAmount) * 100
      : 0;

  const nextPaymentDay = paymentSchedule?.due_by_day
    ? getOrdinalDay(paymentSchedule.due_by_day)
    : null;

  const nextPaymentDate = paymentSchedule?.next_scheduled_due_date
    ? format(new Date(paymentSchedule.next_scheduled_due_date), "d MMM yyyy")
    : null;

  const nextPaymentDateLong = paymentSchedule?.next_scheduled_due_date
    ? format(
        new Date(paymentSchedule.next_scheduled_due_date),
        "do 'of' MMM yyyy",
      )
    : null;

  return {
    ...account,
    percentagePaid,
    accountClosed: accountStatus === "CLOSED",
    nextPaymentDay,
    nextPaymentDate,
    nextPaymentDateLong,
    loanTerm: formatLoanTerm(currentLoanTerm),
    isNoPaymentRequired,
    isFinalPayment,
    isNormalPayment,
    greekable: false,
    type: "PERSONAL_LOAN",
  };
}
